// extracted by mini-css-extract-plugin
export default {"layout_Wrapper":"nomalLayout_layout_Wrapper__jMK2V"};